import FlipMove from 'react-flip-move';
import { HarmonyIcon } from '@rsos/assets/icons';
import { Box, Text } from '@rsos/base-components';
import type { KeywordSet } from '@rsos/reduxDataStore';
import {
  StyledHarmonyWrapper,
  StyledPlusIcon,
  StyledTag,
} from './KeywordRecommendations.styles';
import { useKeywordRecommendations } from './useKeywordRecommendations';

export const KeywordRecommendations = ({
  keywordSet,
  onChange,
}: {
  keywordSet: KeywordSet;
  onChange: (newWords: string[], suggestion: string) => void;
}) => {
  const {
    recommendations,
    removeRecommendation,
    pauseRecommendations,
    startRecommendations,
    thinking,
  } = useKeywordRecommendations(keywordSet);

  const add = (word: string) => {
    removeRecommendation(word);
    onChange([...keywordSet.keywords, word], word);
  };

  const message = () => {
    if (recommendations.length === 0) {
      if (thinking) {
        return (
          <Text key="think" color="primaryText" size="xsmall" mt="4px">
            Checking for suggestions...
          </Text>
        );
      } else {
        return (
          <Text key="fail" color="primaryText" size="xsmall" mt="4px" mb="20px">
            No suggestions available.
          </Text>
        );
      }
    } else {
      return null;
    }
  };

  return (
    <div
      onMouseEnter={() => pauseRecommendations()}
      onMouseLeave={() => startRecommendations()}
    >
      <Box horizontal mt="16px" align="center" color="primaryText">
        <HarmonyIcon width={14} height={9} />{' '}
        <Text size="xsmall">Suggested by HARMONY</Text>
      </Box>
      {message()}
      <FlipMove enterAnimation="elevator" leaveAnimation="fade">
        {recommendations.map(r => (
          <StyledHarmonyWrapper key={r} onClick={() => add(r)}>
            <StyledTag>
              {r} <StyledPlusIcon width={10} height={10} />
            </StyledTag>
          </StyledHarmonyWrapper>
        ))}
      </FlipMove>
    </div>
  );
};
